import { writable, derived } from 'svelte/store';
import { companiesApi } from './api.js';

/** All companies the user has access to */
export const companies = writable([]);

/** Currently active company ID */
export const activeCompanyId = writable(localStorage.getItem('sdi-active-company') || '');

/** Currently active company object */
export const activeCompany = derived(
  [companies, activeCompanyId],
  ([$companies, $id]) => $companies.find(c => c.id === $id) || null,
);

export const companiesLoading = writable(false);

/**
 * Load the user's companies and set active company.
 */
export async function loadCompanies() {
  companiesLoading.set(true);
  try {
    const list = await companiesApi.list();
    companies.set(list);

    // If no active company set, pick the first one
    const stored = localStorage.getItem('sdi-active-company');
    if (list.length > 0) {
      if (!stored || !list.find(c => c.id === stored)) {
        setActiveCompany(list[0].id);
      }
    }
  } catch (error) {
    console.error('Failed to load companies:', error);
    companies.set([]);
  } finally {
    companiesLoading.set(false);
  }
}

/**
 * Switch active company.
 *
 * The store and localStorage are updated first so the UI switches immediately,
 * then the server is told: POST /:companyId/switch moves the `isDefault` flag
 * on the company_users row, which is what decides the company the user lands in
 * on another browser or after clearing local data. Deliberately not awaited —
 * the switch is a local decision and must not wait on the network — but a
 * failure is logged rather than swallowed, because the symptom otherwise is a
 * default that silently stops following the user around.
 */
export function setActiveCompany(companyId) {
  activeCompanyId.set(companyId);
  localStorage.setItem('sdi-active-company', companyId);
  if (!companyId) return;
  companiesApi.switchTo(companyId).catch((error) => {
    console.warn('Could not persist the active company server-side:', error);
  });
}
